import DataGrid, { Column, Pager, Paging, Scrolling, SearchPanel, Selection, Summary, TotalItem } from 'devextreme-react/cjs/data-grid';
import CustomStore from 'devextreme/data/custom_store';
import useHasPermission from 'hooks/useHasPermission';
import { Card } from 'react-bootstrap';
import { getpoInwardAndInventory } from '../services/po.stock.service';
import { useRef, useState } from 'react';
import notistack from 'pages/Core/Notistack';
import AssignToStore from './AssignToStore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage } from '@fortawesome/free-solid-svg-icons';
import ImagePreview, { ImagePreviewRef } from 'Common/ImagePreview';


const POInventory = () => {

    const HasPermission = useHasPermission()

    const [refreshKey, setRefreshKey] = useState(0)

    const imageModalRef = useRef<ImagePreviewRef>(null)

    const reloadDataSource = () => {
        setRefreshKey((prev) => prev + 1)
        handlePOClose()
    }

    const dataSource = (): any | undefined => {
        return new CustomStore({
            key: "id",
            load: async (loadOptions) => {
                try {

                    const { searchValue } = loadOptions

                    const parameterList = new URLSearchParams()

                    const search = JSON.parse(JSON.stringify(loadOptions))

                    for (const [key, value] of Object.entries(search)) {
                        parameterList.append(key, JSON.stringify(value))
                    }

                    if (searchValue) {
                        parameterList.append("search", searchValue)
                    }

                    parameterList.append("isRecieved", "true")

                    const response = await getpoInwardAndInventory(parameterList)

                    return response

                } catch (error) {

                    console.error("Data loading error:", error)

                    return { data: [], totalCount: 0 }

                }
            },
        })
    }

    const selectedRowsRef = useRef<any[]>([])

    const [modalOpen, setModalOpen] = useState(false)

    const dataGridRef = useRef<any>(null)

    const editModalRef = useRef<any>(null)

    const handleSelection = (e: any) => {
        selectedRowsRef.current = e.selectedRowsData
    }

    const handleButtonClick = () => {

        if (!Boolean(selectedRowsRef.current && selectedRowsRef.current.length > 0)) {
            return notistack.warning('Please select at least one product.')
        }

        setModalOpen(true)

        editModalRef.current?.open(selectedRowsRef.current)

    }

    const handlePOClose = () => {

        selectedRowsRef.current = []

        setModalOpen(false)

        dataGridRef.current?.instance?.clearSelection()

    }

    return (
        <>
            <div className="page-content">
                <div className="container-fluid">

                    <Card>

                        <Card.Header className="d-flex justify-content-between align-items-center">
                            <h5 className="m-0">PO Inventory</h5>

                            {HasPermission("ItemMaster.Write") && <button
                                onClick={() => {
                                    handleButtonClick()
                                }}
                                className="btn btn-sm"
                                style={{ border: "1px solid #000" }}
                            >
                                Assign to Store
                            </button>}

                        </Card.Header>

                        <Card.Body>

                            {HasPermission("ItemMaster.Read") ? (

                                <DataGrid
                                    dataSource={dataSource()}
                                    ref={dataGridRef}
                                    remoteOperations={{ groupPaging: true }}
                                    showRowLines={true}
                                    keyExpr="id"
                                    showBorders={true}
                                    key={refreshKey}
                                    columnAutoWidth={true}
                                    onContentReady={(e) => {

                                        const hasData = e.component.totalCount() > 0

                                        e.component.option("pager.visible", hasData)

                                        e.component.option("paging.visible", hasData)

                                    }}
                                    onSelectionChanged={handleSelection}
                                >

                                    <Selection mode='multiple' />

                                    <Pager
                                        showPageSizeSelector
                                        allowedPageSizes={[10, 25, 50, 100]}
                                        showNavigationButtons
                                        displayMode="full"
                                        showInfo
                                    />

                                    <Scrolling
                                        mode="standard"
                                        useNative={true}
                                        scrollByContent={true}
                                        scrollByThumb={true}
                                    />

                                    <SearchPanel
                                        visible={true}
                                        width={240}
                                        placeholder="Search..."
                                    />

                                    <Summary>
                                        <TotalItem />
                                    </Summary>

                                    <Paging defaultPageSize={10} />

                                    <Column dataField="id" dataType="number" sortOrder="desc" width={150} visible={false} />

                                    {HasPermission("ItemMaster.Write") && (

                                        <Column
                                            allowFiltering={false}
                                            caption="Action"
                                            cssClass="text-center"
                                            cellRender={({ data }) => (

                                                <div className="d-flex justify-content-center align-items-center gap-2">

                                                    {data?.invoiceUrl &&

                                                        <button
                                                            className="btn btn-sm action-btn"
                                                            title="View Image"
                                                            onClick={() => {
                                                                imageModalRef.current?.open(data?.invoiceUrl)
                                                            }}
                                                        >

                                                            <FontAwesomeIcon icon={faImage} className="ml-2 text-primary" />

                                                        </button>

                                                    }

                                                </div>

                                            )}
                                        />

                                    )}

                                    <Column dataField="poInvoiceNo" caption="Invoice No." dataType="string" />
                                    <Column dataField="productName" caption="Product Name" dataType="string" />

                                    <Column dataField="styleNo" caption="Style No" dataType="string" />

                                    <Column dataField="materialType" caption="Material Type" dataType="string" />

                                    <Column dataField="karat" caption="Karat" dataType="string" />

                                    <Column dataField="standardGoldWeight" caption="Std Gold Wt" format="#,##0.000" />

                                    <Column dataField="standardDiamondWeight" caption="Std Diamond Wt" format="#,##0.000" />

                                    <Column dataField="expectedGoldRate" caption="Expected Gold Rate" format="#,##0.000" />

                                    <Column dataField="qty" caption="Quantity" dataType="number" />

                                    <Column dataField="status" caption="Status" dataType="string" />

                                    <Column dataField="isRecieved" caption="Received" cellRender={({ data }) => <span>{data.isRecieved ? 'Yes' : 'No'}</span>} />

                                    <Column dataField="isSRP" caption="Is SRP" cellRender={({ data }) => <span>{data.isSRP ? 'Yes' : 'No'}</span>} />

                                    <Column dataField="actualGoldWeight" caption="Actual Gold Wt" format="#,##0.000" />

                                    <Column dataField="actualDiamondWeight" caption="Actual Diamond Wt" format="#,##0.000" />

                                    <Column dataField="craftsmanshipCost" caption="Craftsmanship Rate" format="#,##0.00" />
                                    <Column dataField="goldCost" caption="Gold Rate" format="#,##0.00" />
                                    <Column dataField="diamondCost" caption="Diamond Rate" format="#,##0.00" />
                                    <Column dataField="makingCharges" caption="Making Charges" format="#,##0.00" />
                                    <Column dataField="otherCharges" caption="Other Charges" format="#,##0.00" />
                                    <Column dataField="totalCost" caption="Selling Price" format="#,##0.00" />
                                    <Column dataField="dpPrice" caption="DP Price" format="#,##0.00" />

                                    <Column dataField="bagNumber" caption="Bag Number" />

                                    <Column dataField="specialInstructions" caption="Special Instructions" width={250} />

                                </DataGrid>

                            ) : null}

                        </Card.Body>

                    </Card>

                </div>
            </div>

            <AssignToStore
                ref={editModalRef}
                reloadDataSource={reloadDataSource}
            />

            <ImagePreview
                ref={imageModalRef}
            />

        </>
    )
}

export default POInventory